import { Types } from '../../../actions/content/media'
import { Types as MSTypes } from '../../../actions/content/media/mediaSchedule'
import { ArrayUtils } from '../../../utils'
import initialState from '../initialState'
import { formatMedia, getMediaList, setCountFailure, setCountRequest, setCountSuccess, updateMedia } from './helpers'

export default (state, { type, payload = {}, meta = {} }) => {
    switch (type) {
        case Types.FETCH_MEDIA_REQUEST:
            const { media } = meta.noFirstPage ? state : initialState

            return {
                ...state,
                isWorking: {
                    ...state.isWorking,
                    media: true,
                },
                media,
            }
        case Types.FETCH_MEDIA_SUCCESS: {
            const data = payload.data.map(formatMedia)

            return {
                ...state,
                isWorking: {
                    ...state.isWorking,
                    media: false,
                },
                media: meta.noFirstPage ? [...state.media, ...data] : data, // If paginating, preserve old data
                pagination: {
                    ...state.pagination,
                    media: {
                        currentPage: payload.current_page,
                        perPage: payload.per_page,
                        total: payload.total,
                        from: payload.from,
                        to: payload.to,
                    },
                },
            }
        }
        case Types.APPROVE_MEDIA_REQUEST:
        case Types.FETCH_MEDIA_DETAILS_REQUEST:
        case Types.MEDIA_PUSH_STATUS_REQUEST:
        case Types.TEST_MEDIA_REQUEST:
            return {
                ...state,
                isWorking: {
                    ...state.isWorking,
                    mediaSingle: true,
                },
                selected: {
                    ...state.selected,
                    media: initialState.selected.media,
                },
            }
        case Types.APPROVE_MEDIA_FAILURE:
        case Types.FETCH_MEDIA_DETAILS_FAILURE:
        case Types.MEDIA_PUSH_STATUS_FAILURE:
        case Types.TEST_MEDIA_FAILURE:
            return {
                ...state,
                isWorking: {
                    ...state.isWorking,
                    mediaSingle: false,
                },
            }
        case Types.APPROVE_MEDIA_SUCCESS:
        case Types.TEST_MEDIA_SUCCESS:
        case Types.MEDIA_PUSH_STATUS_SUCCESS:
        case Types.FETCH_MEDIA_DETAILS_SUCCESS: {
            const decrementCount = (countKey) => {
                return {
                    ...state.counts,
                    [countKey]: {
                        ...state.counts[countKey],
                        count: state.counts[countKey].count - 1,
                    },
                }
            }
            let { counts } = state

            if (type === Types.APPROVE_MEDIA_SUCCESS) {
                counts = decrementCount('pendingApprovalMedia')
            } else if (type === Types.TEST_MEDIA_SUCCESS) {
                counts = decrementCount('pendingTestMedia')
            } else if (type === Types.MEDIA_PUSH_STATUS_SUCCESS) {
                counts = decrementCount('pendingPushMedia')
            }

            const data = formatMedia(payload)
            const selectedMedia = state.selected.media || {}

            return {
                ...state,
                counts,
                isWorking: {
                    ...state.isWorking,
                    mediaSingle: false,
                },
                selected: {
                    ...state.selected,
                    media: {
                        ...selectedMedia,
                        ...data,
                    },
                },
            }
        }
        case Types.CREATE_MEDIA_SUCCESS: {
            return {
                ...state,
                media: [formatMedia(payload || {}), ...state.media],
            }
        }
        case Types.CHANGE_MEDIA: {
            return {
                ...state,
                media: payload,
            }
        }
        case Types.DELETE_MEDIA_SUCCESS: {
            const { mediaID } = meta
            const index = state.media.findIndex((m) => m.id === mediaID)
            if (index < 0) {
                return state
            }

            return {
                ...state,
                media: ArrayUtils.removeItem(state.media, index),
            }
        }
        case Types.RETRY_UPLOAD_MEDIA_REQUEST: {
            const { mediaID, inSelectedPlaylist } = meta

            return updateMedia(state, mediaID, { isWorking: true }, inSelectedPlaylist)
        }
        case Types.ATTACH_MEDIA_PLAYLIST_SUCCESS:
        case Types.DETACH_MEDIA_PLAYLIST_SUCCESS:
        case Types.FETCH_SINGLE_MEDIA_SUCCESS:
        case Types.RETRY_UPLOAD_MEDIA_SUCCESS: {
            const { id: mediaID } = payload
            const { inSelectedPlaylist } = meta

            return updateMedia(state, mediaID, formatMedia(payload), inSelectedPlaylist)
        }
        case Types.UPDATE_MEDIA_SUCCESS: {
            const { id: mediaID } = payload

            return updateMedia(state, mediaID, formatMedia(payload), false)
        }
        case MSTypes.CREATE_MEDIA_SCHEDULE_SUCCESS:
        case MSTypes.UPDATE_MEDIA_SCHEDULE_SUCCESS: {
            const { id, media_id: mediaID } = payload
            const { inSelectedPlaylist } = meta
            const mediaList = getMediaList(state, inSelectedPlaylist)

            const mediaIndex = mediaList.findIndex((m) => m.id === mediaID)
            if (mediaIndex < 0) {
                return state
            }

            const selectedMedia = mediaList[mediaIndex]
            const { schedules = [] } = selectedMedia || {}

            const index = schedules.findIndex((s) => s.id === id)
            const newSchedule = ArrayUtils.insertItem(schedules, index < 0 ? index : schedules.length, formatMedia(payload))

            return updateMedia(state, mediaID, formatMedia({ ...selectedMedia, schedules: newSchedule }), inSelectedPlaylist)
        }
        case MSTypes.DELETE_MEDIA_SCHEDULE_SUCCESS: {
            const { inSelectedPlaylist, id, mediaID } = meta
            const mediaList = getMediaList(state, inSelectedPlaylist)

            const mediaIndex = mediaList.findIndex((m) => m.id === mediaID)
            if (mediaIndex < 0) {
                return state
            }

            const selectedMedia = mediaList[mediaIndex]
            const { schedules = [] } = selectedMedia || {}

            const index = schedules.findIndex((s) => s.id === id)
            if (index < 0) {
                return state
            }

            const newSchedules = ArrayUtils.removeItem(schedules, index)

            return updateMedia(state, mediaID, { schedules: newSchedules }, inSelectedPlaylist)
        }
        case Types.FETCH_MEDIA_PENDING_APPROVAL_COUNT_FAILURE: {
            return setCountFailure(state, 'pendingApprovalMedia')
        }
        case Types.FETCH_MEDIA_PENDING_APPROVAL_COUNT_REQUEST: {
            return setCountRequest(state, 'pendingApprovalMedia')
        }
        case Types.FETCH_MEDIA_PENDING_APPROVAL_COUNT_SUCCESS: {
            return setCountSuccess(state, 'pendingApprovalMedia', payload?.count)
        }
        case Types.FETCH_MEDIA_PENDING_PUSH_COUNT_FAILURE: {
            return setCountFailure(state, 'pendingPushMedia')
        }
        case Types.FETCH_MEDIA_PENDING_PUSH_COUNT_REQUEST: {
            return setCountRequest(state, 'pendingPushMedia')
        }
        case Types.FETCH_MEDIA_PENDING_PUSH_COUNT_SUCCESS: {
            return setCountSuccess(state, 'pendingPushMedia', payload?.count)
        }
        case Types.FETCH_MEDIA_PENDING_TEST_COUNT_FAILURE: {
            return setCountFailure(state, 'pendingTestMedia')
        }
        case Types.FETCH_MEDIA_PENDING_TEST_COUNT_REQUEST: {
            return setCountRequest(state, 'pendingTestMedia')
        }
        case Types.FETCH_MEDIA_PENDING_TEST_COUNT_SUCCESS: {
            return setCountSuccess(state, 'pendingTestMedia', payload?.count)
        }
        default:
            return null
    }
}
